import { defineComponent as u, openBlock as o, createElementBlock as e, mergeProps as i, unref as l, renderSlot as A, createElementVNode as a, createCommentVNode as g } from "vue";
import { useScalarIcon as h } from "../hooks/useScalarIcon.js";
const m = { key: 0 }, f = { key: 1 }, H = { key: 2 }, k = { key: 3 }, M = { key: 4 }, Z = { key: 5 }, w = {
  name: "ScalarIconNumberThree"
}, V = /* @__PURE__ */ u({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = h(s);
    return (p, t) => (o(), e("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(d)), [
      A(p.$slots, "default"),
      l(n) === "bold" ? (o(), e("g", m, t[0] || (t[0] = [
        a("path", { d: "M180,160A60,60,0,0,1,80,204.72a12,12,0,1,1,16-17.88A36,36,0,1,0,120,124a12,12,0,0,1-9.6-19.2L144,60H88a12,12,0,0,1,0-24h80a12,12,0,0,1,9.6,19.2l-36.48,48.64A60.11,60.11,0,0,1,180,160Z" }, null, -1)
      ]))) : l(n) === "duotone" ? (o(), e("g", f, t[1] || (t[1] = [
        a("path", {
          d: "M216,40V216a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V40A16,16,0,0,1,56,24H200A16,16,0,0,1,216,40Z",
          opacity: "0.2"
        }, null, -1),
        a("path", { d: "M176,160a56,56,0,0,1-93.33,41.74,8,8,0,1,1,10.66-11.92A40,40,0,1,0,120,120a8,8,0,0,1-6.4-12.8L152,56H88a8,8,0,0,1,0-16h80a8,8,0,0,1,6.4,12.8l-39.84,53.12A56.1,56.1,0,0,1,176,160Z" }, null, -1)
      ]))) : l(n) === "fill" ? (o(), e("g", H, t[2] || (t[2] = [
        a("path", { d: "M200,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24ZM124,192a43.85,43.85,0,0,1-34.22-16.34,8,8,0,0,1,12.44-10.06A28,28,0,1,0,126,120.07a8,8,0,0,1-5.58-13.1l22.48-27H96a8,8,0,0,1,0-16h64a8,8,0,0,1,6.15,13.12l-25.23,30.27A44,44,0,0,1,124,192Z" }, null, -1)
      ]))) : l(n) === "light" ? (o(), e("g", k, t[3] || (t[3] = [
        a("path", { d: "M174,160a54,54,0,0,1-90,40.25,6,6,0,1,1,8-8.94A42,42,0,1,0,120,118a6,6,0,0,1-4.8-9.6L156,54H88a6,6,0,0,1,0-12h80a6,6,0,0,1,4.8,9.6l-41.67,55.55A54.1,54.1,0,0,1,174,160Z" }, null, -1)
      ]))) : l(n) === "regular" ? (o(), e("g", M, t[4] || (t[4] = [
        a("path", { d: "M176,160a56,56,0,0,1-93.33,41.74,8,8,0,1,1,10.66-11.92A40,40,0,1,0,120,120a8,8,0,0,1-6.4-12.8L152,56H88a8,8,0,0,1,0-16h80a8,8,0,0,1,6.4,12.8l-39.84,53.12A56.1,56.1,0,0,1,176,160Z" }, null, -1)
      ]))) : l(n) === "thin" ? (o(), e("g", Z, t[5] || (t[5] = [
        a("path", { d: "M172,160a52,52,0,0,1-86.67,38.76,4,4,0,1,1,5.34-6A44,44,0,1,0,120,116a4,4,0,0,1-3.2-6.4L160,52H88a4,4,0,0,1,0-8h80a4,4,0,0,1,3.2,6.4l-43.61,58.15A52.08,52.08,0,0,1,172,160Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  V as default
};
